import { render, staticRenderFns } from "./PatientUAE.vue?vue&type=template&id=0be60908&"
import script from "./PatientUAE.vue?vue&type=script&lang=js&"
export * from "./PatientUAE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports